import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  mood: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    textOverflow: 'ellipsis',
    flexWrap: 'wrap',
  },
}));

export default useStyles;
